import React, { useEffect, useState } from 'react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Box, Link, Button, FormControl, FormLabel, Spinner, Text, Textarea, VStack, Heading, useToast } from '@chakra-ui/react'
import { Link as ReachLink } from "react-router-dom";
import axios from 'axios';
import { TARM_AWS_URL } from '../../api/api';

const SQLQuery = () => {
    const [source] = useState(axios.CancelToken.source());
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [downloadLink, setDownloadLink] = useState('')
    const [filename, setFileName] = useState('')
    const [query, setQuery] = useState('')
    const toast = useToast();

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(query)
        if (downloadLink) setDownloadLink('')
        genaiSearchHandler(query)
    }


    const genaiSearchHandler = async (query) => {
        try {
            setIsBtnLoading(true)
            const response = await TARM_AWS_URL.post("execute-sql", {
                sql_query: query,
            },
                {
                    cancelToken: source.token,
                })
            console.log(response)
            if (response.status === 200) {
                const link = response.data.presigned_url
                const filename = response.data.filename
                setFileName(filename)
                setDownloadLink(link)
            }
        } catch (error) {
            console.error(error)
            toast({
                title: error.message,
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setIsBtnLoading(false)
        }
    }

    useEffect(() => {
        return () => {
            if (source) {
                source.cancel();
            }
        };
    }, []);


    return (
        <VStack>
            <Heading>SQL Query</Heading>
            <br />
            <Box width="55%" borderWidth="3px" borderRadius="lg" p="10">
                <form onSubmit={handleSubmit}>
                    <FormControl isRequired>
                        <FormLabel>Drop your SQL query and we will fetch all the maching results</FormLabel>
                        <Textarea
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder='Start writing your sql query here...'
                            resize="vertical"
                            height={40}
                            mt={2}
                        />
                    </FormControl>
                    <Box textAlign="end" mt="4">
                        <Button
                            type="submit"
                            colorScheme="blue"
                            disabled={!query || isBtnLoading}
                        >
                            {isBtnLoading && <Spinner size="sm" mr={2} />}
                            Submit
                        </Button>
                    </Box>
                </form>
                <Box textAlign="center">
                    {
                        downloadLink &&
                        <Box>
                            <Text>Download results: </Text>
                            <Link color='blue.500' href={downloadLink}>
                                {filename}
                            </Link>
                            <br />
                            <Link
                                color='blue.500'
                                as={ReachLink}
                                to={
                                    '/home/gen-ai/grid/' + filename
                                }
                                isExternal
                            >
                                View results in grid
                                <ExternalLinkIcon mx="5px" />
                            </Link>
                        </Box>
                    }
                </Box>
            </Box>
        </VStack>
    )
}

export default SQLQuery